export default __webpack_public_path__ + "static/media/Priest's Boots of the Nine Springs.a035cf39.jpg";